import React from 'react'
import { Link } from 'react-router-dom'
import qs from 'qs'

const queryParamAwareLink = ({ children, stripParams, ...props }) => {
  let to = props.to

  if (!stripParams) {
    // Future versions of react-router-dom have useLocation() for this purpose
    const urlQuery = window.location.search
    const urlParams = qs.parse(urlQuery, { ignoreQueryPrefix: true })

    const linkPair = (props.to || '').split('?')
    const linkHead = linkPair[0]
    const linkQuery = linkPair[1]
    const linkParams = qs.parse(linkQuery, { ignoreQueryPrefix: true })

    const mergedParams = { ...urlParams, ...linkParams }
    const mergedQuery = qs.stringify(mergedParams)

    to = `${linkHead}?${mergedQuery}`
  }

  return (
    <Link { ...props } to={ to } >
      { children }
    </Link>
  )
}

export { queryParamAwareLink as Link }



// WEBPACK FOOTER //
// ./src/shared/components/Link.js